import { ISubMenu } from "@interfaces/ISubMenu";
import { i18n } from "@translations/i18n";
import { EDirectoryPreferences } from "@features/Profile/NationalDirectoryEnquiries/interface/INDDPreference";
import { TypographyProps } from "@mui/material";

/* GLOBAL */
export const isMobileSize = window.innerWidth <= 768;

export const BRAND_NAME = "GoMo";

export const STORAGE = "eir-myaccount";

// <editor-fold desc="APPLICATION PAGES URL" defaultstate="collapsed">
export const HOME_PAGE_URL = "/home";

export const BILLS_PAGE_URL = "/bills";

export const USAGE_PAGE_URL = "/usage";

export const CART_PAGE_URL = "/cart";

export const CONFIRMATION_PAGE_URL = "/confirmation";

export const PROFILE_PAGE_URL = "/profile";

export const REGISTER_PAGE_URL = "/register";

export const PAYMENTS_PAGE_URL = "/payments";

export const FORGOT_EMAIL_PAGE_URL = "/forgot_email";

export const EMAIL_VERIFICATION_PAGE_URL = "/email_verification";

export const ALERTS_PAGE_URL = "/alerts";

export const ACCOUNT_DETAILS_PAGE_URL = "/account_details";

export const ADDONS_PAGE_URL = `${ACCOUNT_DETAILS_PAGE_URL}/addons`;

export const PORTIN_PAGE_URL = `${ACCOUNT_DETAILS_PAGE_URL}/port_in`;

export const MANAGE_SIM_URL = `${ACCOUNT_DETAILS_PAGE_URL}/manage_sim`;

export const BARRINGS_PAGE_URL = `${ACCOUNT_DETAILS_PAGE_URL}/barrings`;

export const CANCEL_NUMBER_PAGE_URL = `${ACCOUNT_DETAILS_PAGE_URL}/cancel_number`;

export const CANCEL_BROADBAND_PAGE_URL = `${ACCOUNT_DETAILS_PAGE_URL}/cancel_broadband`;

export const ORDERS_PAGE_URL = `${ACCOUNT_DETAILS_PAGE_URL}/orders`;

export const { WORDPRESS_URL, ESHOP_URL, GOMO_WORLD_URL, MYACCOUNT_URL } = process.env;

export const HELP_SUPPORT_URL = `${WORDPRESS_URL}/help-support/`;

export const MOBILE_ESHOP_URL = `${ESHOP_URL}/mobile-sim-only`;

export const BROADBAND_ESHOP_URL = `${ESHOP_URL}/broadband`;

export const ABOUT_URL = `${WORDPRESS_URL}/about-gomo/`;

export const URLS = {
    ACCOUNT_DETAILS_PAGE_URL,
    ADDONS_PAGE_URL,
    ALERTS_PAGE_URL,
    BARRINGS_PAGE_URL,
    BILLS_PAGE_URL,
    USAGE_PAGE_URL,
    CANCEL_NUMBER_PAGE_URL,
    CART_PAGE_URL,
    CANCEL_BROADBAND_PAGE_URL,
    CONFIRMATION_PAGE_URL,
    EMAIL_VERIFICATION_PAGE_URL,
    FORGOT_EMAIL_PAGE_URL,
    HOME_PAGE_URL,
    MANAGE_SIM_URL,
    ORDERS_PAGE_URL,
    PAYMENTS_PAGE_URL,
    PORTIN_PAGE_URL,
    PROFILE_PAGE_URL,
    REGISTER_PAGE_URL,
    MOBILE_ESHOP_URL,
    BROADBAND_ESHOP_URL,
    ABOUT_URL,
    HELP_SUPPORT_URL,
};
// </editor-fold>

/* API CONSTANTS */

// <editor-fold desc="ENUM" defaultstate="collapsed">
export enum EORDER_STATUS {
    CANCELLED = "Cancelled",
    IN_PROGRESS = "In progress",
    COMPLETED = "Completed",
}

export enum EORDER_TYPE {
    CROSS_SELL = "New plan",
    ACQUISITION = "New plan",
    REPLACEMENT = "Replacement SIM",
}

export enum EPAYMENT_TYPES_NAME {
    CREDIT_CARD = "Credit Card",
}

export enum EPAYMENT_TYPES {
    CREDIT_CARD = "CREDIT_CARD",
}

export enum EADDRESS_TYPES {
    BILLING = "BILLING",
    DELIVERY = "DELIVERY",
}

export enum ENUMBER_TYPES {
    FAX = "FAX",
    FIXE = "FIXE",
    MOBILE = "MOBILE",
}
// </editor-fold>

/* USER UTILS */
export const ACTIVE_CUSTOMER = "ACTIVE_CUSTOMER";

export const NO_LONGER_CUSTOMER = "NO_LONGER_CUSTOMER";

export const ALLOW_3RD_PARTIES = "ALLOW_3RD_PARTIES";

export const NationalDirectoryEnquiriesList = [
    {
        label: i18n.t("Listed"),
        name: EDirectoryPreferences.LISTED,
        value: false,
    },
    {
        label: i18n.t("Unlisted"),
        name: EDirectoryPreferences.UNLISTED,
        value: false,
    },
    {
        label: i18n.t("Ex-Directory"),
        name: EDirectoryPreferences.EXDIRECTORY,
        value: false,
    },
];

export const SubMenuList: ISubMenu[] = [
    {
        label: `${i18n.t("navigation:myHome", { brand: BRAND_NAME })}`,
        url: HOME_PAGE_URL,
    },
    {
        label: i18n.t("navigation:myAlerts"),
        url: ALERTS_PAGE_URL,
    },
    {
        label: i18n.t("navigation:myBills"),
        url: BILLS_PAGE_URL,
    },
    {
        label: i18n.t("navigation:myUsage"),
        url: USAGE_PAGE_URL,
    },
    {
        label: i18n.t("navigation:myPayments"),
        url: PAYMENTS_PAGE_URL,
    },
    {
        label: i18n.t("navigation:accountDetails"),
        url: ACCOUNT_DETAILS_PAGE_URL,
    },
    {
        label: i18n.t("navigation:myProfile"),
        url: PROFILE_PAGE_URL,
    },
    {
        isExternal: true,
        label: i18n.t("navigation:contactUs"),
        url: `${WORDPRESS_URL}/contact`,
    },
];
// </editor-fold>

export const DATE_FORMAT = "dd/MM/yyyy";

export const API_DATE_FORMAT = "yyyy-MM-dd";

export const TIME_FORMAT = "HH:mm";

// Subscription
export const MOBILE_DOMAIN = "MOBILE";

// Order
export const COMPLETED_ORDER_STATUS = "COMPLETED";

export const OFFER_CONFIG = {
    BRAND: "GOMO",
    CHANNEL: "MYACCOUNT",
    CHANNEL_TYPE: "DIRECT",
};

// <editor-fold desc="TITLE STYLE" defaultstate="collapsed">
export const TITLE_INHERIT_STYLE: Partial<TypographyProps> = { variant: "h2", color: "inherit", align: "center" };

export const TITLE_PRIMARY_STYLE: Partial<TypographyProps> = { variant: "h2", color: "primary", align: "center" };
// </editor-fold>

export const MONTH_LIST = [
    { label: i18n.t("month:january"), value: 1 },
    { label: i18n.t("month:february"), value: 2 },
    { label: i18n.t("month:march"), value: 3 },
    { label: i18n.t("month:april"), value: 4 },
    { label: i18n.t("month:may"), value: 5 },
    { label: i18n.t("month:june"), value: 6 },
    { label: i18n.t("month:july"), value: 7 },
    { label: i18n.t("month:august"), value: 8 },
    { label: i18n.t("month:september"), value: 9 },
    { label: i18n.t("month:october"), value: 10 },
    { label: i18n.t("month:november"), value: 11 },
    { label: i18n.t("month:december"), value: 12 },
];

export const USAGE_SERVICE_TYPE = "POSTPAY";

export const RECORDS_PER_PAGE = [10, 20, 50, 100];

export const MERGE_PATCH_HEADER = {
    "Content-Type": "application/merge-patch+json",
};

export const JSON_HEADER = {
    accept: "application/json",
};

export const PAYMENT_STANCER_URL = "https://payment.stancer.com";

export const PAYMENT_AUTHENTICATION_REQUIRED = "payment-authentication-required";

export enum EHttpCode {
    BAD_REQUEST = 400,
}
